module.exports = __webpack_public_path__ + "img/map.aad5b264.jpg";